// Expects legacy-critical to be defined

import Decimal from 'decimal.js-light'
window.Decimal = Decimal;

import Dropzone from 'dropzone'
Dropzone.autoDiscover = false;
Dropzone.prototype.defaultOptions.timeout = 5*60*60*1000; // 5 hours, it should be the server time-outing, not the client.
Dropzone.prototype.defaultOptions.maxFilesize = 1024;
window.Dropzone = Dropzone;

import Autolinker from 'autolinker'
window.Autolinker = Autolinker;

import AdaliaViewer from '../src/javascripts/adalia_viewer';
window.AdaliaViewer = AdaliaViewer;
import '../src/libs/jquery.ui.draggable'
import '../src/libs/bootstrap-colorpicker.min'
import '../src/libs/Chart.bundle.min'
import '../src/libs/jquery.iframe-transport'
import '../src/libs/jquery.ui.widget'
import '../src/libs/jquery.fileupload'
import '../src/libs/jquery.multi-select.min'

import '../src/javascripts/locationpicker.jquery'
import '../src/javascripts/modal_dialog'
import '../src/javascripts/resizable_pages'
import '../src/javascripts/budget_calculator'
import '../src/javascripts/evaluation_form'
import '../src/javascripts/adalia_discussion'
import '../src/javascripts/sms_confirmation'
import '../src/javascripts/site_help'
import '../src/javascripts/external_integration'
import '../src/javascripts/legacy_concept_form'
import '../src/javascripts/result_framework'
import '../src/javascripts/localStorage_cleanup.js'


import { ActionJS_ProjectCall } from '../src/javascripts/project_call'
import { Project } from '../src/javascripts/project'
import { ProjectCallPhase } from '../src/javascripts/project_call_phase'
import { Programme, ProgrammeIndicatorUnit } from '../src/javascripts/programme'
import { UserType } from '../src/javascripts/user_type'
import { Monitoring } from '../src/javascripts/monitoring'
import { Payment } from '../src/javascripts/payment'
import { Administration, UserAgreement } from '../src/javascripts/administration'
import { Applicant } from '../src/javascripts/applicant'
import { ExternalEvaluator } from '../src/javascripts/external_evaluator'
import { Report, ReportVariable } from '../src/javascripts/report'
import { ProjectMilestone } from '../src/javascripts/project_milestone'
import { Budget } from '../src/javascripts/budget'
import { Partner } from '../src/javascripts/partner'
import { ProgrammeForm } from '../src/javascripts/programme_form'
import { ProgrammeFactSheet} from '../src/javascripts/programme_fact_sheet'
import { Task } from '../src/javascripts/task'
import { GrantContract } from '../src/javascripts/grant_contract'
import { Faq } from '../src/javascripts/faq'
import { DelayedJob } from '../src/javascripts/delayed_job'
import { SupportForm } from '../src/javascripts/support_form'
import { Support } from '../src/javascripts/support'
import { MonitoringReport } from '../src/javascripts/monitoring_report'
import { ProjectReport } from '../src/javascripts/project_report'
import { Integration } from '../src/javascripts/integration'
import { ResultFrameworkTemplate } from '../src/javascripts/result_framework_template'
import { ProjectUserGroup } from '../src/javascripts/project_user_group'
import { DashboardLegacy } from '../src/javascripts/dashboard_legacy.js'
import { Dashboard } from '../src/javascripts/dashboard.js'
import { Dataset } from '../src/javascripts/dataset'
import { Datagrid } from '../src/javascripts/datagrid'
import { FinancialDatagrid } from '../src/javascripts/financial_datagrid'
import { RiskDatagrid } from '../src/javascripts/risk_datagrid.js';
import { DatagridCollection } from '../src/javascripts/datagrid_collection'
import { PaymentType } from '../src/javascripts/payment_type'
import { UserNotification } from '../src/javascripts/user_notification'
import { GeoJson } from '../src/javascripts/geo_json'
import { WebhookListing } from '../src/javascripts/webhook_listing.js';

ActionJS.ProjectCall = ActionJS_ProjectCall;
ActionJS.Project = Project;
ActionJS.ProjectCallPhase = ProjectCallPhase;
ActionJS.ProjectCallPhase.preview_form = ActionJS.ProjectCallPhase.preview_form.bind(ActionJS.ProjectCallPhase);
ActionJS.Programme = Programme;
ActionJS.ProgrammeIndicatorUnit = ProgrammeIndicatorUnit;
ActionJS.UserType = UserType;
ActionJS.AdminUserType = UserType;
ActionJS.Monitoring = Monitoring;
ActionJS.Payment = Payment;
ActionJS.Administration = Administration;
ActionJS.Applicant = Applicant;
ActionJS.ExternalEvaluator = ExternalEvaluator;
ActionJS.Report = Report;
ActionJS.ProjectMilestone = ProjectMilestone;
ActionJS.Budget = Budget;
ActionJS.Partner = Partner;
ActionJS.ProgrammeForm = ProgrammeForm;
ActionJS.ProgrammeFactSheet = ProgrammeFactSheet;
ActionJS.Task = Task;
ActionJS.GrantContract = GrantContract;
ActionJS.Faq = Faq;
ActionJS.DelayedJob = DelayedJob;
ActionJS.SupportForm = SupportForm;
ActionJS.Support = Support;
ActionJS.MonitoringReport = MonitoringReport;
ActionJS.ProjectReport = ProjectReport;
ActionJS.Integration = Integration;
ActionJS.ResultFrameworkTemplate = ResultFrameworkTemplate;
ActionJS.ProjectUserGroup = ProjectUserGroup;
ActionJS.DashboardLegacy = DashboardLegacy;
ActionJS.Dashboard = Dashboard;
ActionJS.Dataset = Dataset;
ActionJS.Datagrid = Datagrid;
ActionJS.FinancialDatagrid = FinancialDatagrid;
ActionJS.RiskDatagrid = RiskDatagrid;
ActionJS.DatagridCollection = DatagridCollection;
ActionJS.PaymentType = PaymentType;
ActionJS.UserNotification = UserNotification;
ActionJS.UserAgreement = UserAgreement;
ActionJS.GeoJson = GeoJson;
ActionJS.ReportVariable = ReportVariable;
ActionJS.WebhookListing = WebhookListing;



// Big refactoring before next react upgrade, hide warning to have less spam
if (import.meta.env.DEV) {
  const originalError = console.error;

  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes('Support for string refs will be removed')
    ) {
      console.log("String ref deprecation error supressed")
      return;
    }

    originalError(...args);
  };
}
